// `useProperties` — TanStack Query hook for /api/properties.
//
// Used by the dashboard for the FILT-06 county multi-select source list:
// distinct counties are computed in the consumer via Set reduction over the
// full property list. The full list is also cached for Phase 06's properties
// listing page so re-navigating from the dashboard avoids a refetch.
//
// staleTime 60s — counties don't change between job submissions, and the
// county field on Property never updates after initial backfill (D6).

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchProperties, type PropertiesApiRow } from '@/lib/api';

export function useProperties(): UseQueryResult<PropertiesApiRow[], Error> {
  return useQuery<PropertiesApiRow[], Error>({
    queryKey: ['properties'],
    queryFn: ({ signal }) => fetchProperties(signal),
    staleTime: 60_000,
  });
}
